import { NODE_BACK_URL } from '../endpoints';

export const CURRENT_USER_ACCESS_RIGHTS_ENDPOINT = `${NODE_BACK_URL}/api/backoffice-permissions`;
